import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-foreground-500 text-sm">了解平台动态与游戏攻略</p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看更多 <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  title={article.title}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看更多资讯 <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}